import { ICONS, Icon } from 'components/Icon';
import { Pressable } from 'components/Pressable';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  OPEN_BARCODE_SCANNER,
  doAseFieldInstanceSearchBarcode,
} from 'store/actions';
import { selectAseHasFieldInstancesWithQrData } from 'store/assessments/selectors';

const CIRCLE_SIZE = 50;
const ICON_SIZE = CIRCLE_SIZE / 2;

export const QrIndicator: React.FC = () => {
  const dispatch = useDispatch();
  const hasFieldInstanceWithQrData = useSelector(
    selectAseHasFieldInstancesWithQrData,
  );

  if (!hasFieldInstanceWithQrData) {
    return null;
  }

  const handleFindByQrPress = () =>
    dispatch(
      OPEN_BARCODE_SCANNER({
        text: 'scan to find an existing element',
        actionAfter: doAseFieldInstanceSearchBarcode({
          data: '',
          parent: null,
        }),
      }),
    );
  return (
    <Pressable
      style={{
        width: CIRCLE_SIZE,
        height: CIRCLE_SIZE,
        borderRadius: CIRCLE_SIZE,
        backgroundColor: theme.colors.black,
        position: 'absolute',
        zIndex: 999,
        left: 18,
        bottom: 18,
        alignItems: 'center',
        justifyContent: 'center',
        elevation: 5,
        opacity: 0.8,
        shadowColor: theme.colors.black,
        shadowOffset: { height: 0, width: 0 },
        shadowOpacity: 0.8,
        shadowRadius: 1,
      }}
      pressedStyle={{
        opacity: 0.5,
      }}
      onPress={handleFindByQrPress}
    >
      <Icon
        source={ICONS.QRCodeLight}
        size={ICON_SIZE}
        color={theme.colors.white}
      />
    </Pressable>
  );
};
